module.exports = __webpack_public_path__ + "img/my_bookings.c010be48.png";